export enum ActionType {
    COLORPRODUCT = 1,
    OXIDATION,
    COLORTREATMENT,
    PERMPRODUCT,
    FIXATION,
    PERMPRETREATMENT,
    PERMPOSTTREATMENT,
    PERMWRAPPERCHOICE,
    PERMWRAPPERSYSTEM,
    PERMWRAPPERCOLOR,
    PERMWRAPPER
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/shared/enums/actionType.ts